// mutations.js

export default {
    updateNotificationList(state, notificationList){
        state.notificationList = notificationList
    },
};
